import * as clientErrTypes from 'config/clientErrorTypes';
import { reducePointModes } from 'config/enterpriseReducePointMode';
import { checkKKUserExchangePointsStatus } from 'api/client';
import { toLowerCase } from 'utils/manipulateString';
import { generateApiErrObj } from 'client/hooks/useClientErrorHandler';

export default async function checkEntryNeedPoint({ promoUUID, entry, reducePointMode }) {
    if (!reducePointMode) {
        return false;
    }
    const isNeedReducePoint =
        reducePointMode === reducePointModes.POINT_SYSTEMS
            ? !entry.hasPointReduced
            : reducePointMode === reducePointModes.KK_BOX
            ? await checkKKBoxPointStatus({
                  promoUUID,
                  entryUuid: entry.entryUuid
              })
            : !entry.hasPointReduced;
    return isNeedReducePoint;
}

async function checkKKBoxPointStatus({ promoUUID, entryUuid }) {
    const resp = await checkKKUserExchangePointsStatus(promoUUID, entryUuid);
    const { httpStatus, payload } = resp;

    if (httpStatus === 200) {
        const { data: { status } = {} } = payload;
        return Number(status) !== 2;
    } else if (
        httpStatus === 400 &&
        toLowerCase(payload.code) === 'po-r1-fnf1' &&
        payload.message === 'order not found'
    ) {
        return true;
    } else {
        throw generateApiErrObj(resp, clientErrTypes.CHECK_REDUCE_POINT_STATUS);
    }
}
